import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

import {
  Carousel,
  CarouselArrowFloatButtons,
  CarouselDotButtons,
  UseCarouselReturn,
} from '@components/Carousel';

import {
  sxGalleryCarousel,
  sxGalleryCarouselContainer,
  sxGalleryCarouselSlide,
  sxGalleryDots,
  sxGalleryNextArrow,
  sxGalleryPrevArrow,
  sxGallerySlide,
  sxGallerySlideImage,
  sxGalleryTopLeft,
  sxGalleryWrapper,
} from '../styles';

export type GallerySlide = {
  id: number;
  src: string;
  alt?: string;
};

interface IGalleryProps {
  carousel: UseCarouselReturn;
  slides: GallerySlide[];
  topLeftSlot?: ReactNode;
}

const Gallery: FC<IGalleryProps> = ({ carousel, slides, topLeftSlot }) => {
  return (
    <Box sx={sxGalleryWrapper}>
      {topLeftSlot && <Box sx={sxGalleryTopLeft}>{topLeftSlot}</Box>}

      <Carousel
        carousel={carousel}
        sx={sxGalleryCarousel}
        slotProps={{ container: sxGalleryCarouselContainer, slide: sxGalleryCarouselSlide }}
      >
        {slides.map((slide) => (
          <Box key={slide.id} sx={sxGallerySlide}>
            <Box component="img" src={slide.src} alt={slide.alt} sx={sxGallerySlideImage} />
          </Box>
        ))}
      </Carousel>

      {slides.length > 1 && (
        <>
          <CarouselArrowFloatButtons
            {...carousel.arrows}
            options={carousel.options}
            slotProps={{
              prevBtn: { sx: sxGalleryPrevArrow },
              nextBtn: { sx: sxGalleryNextArrow },
            }}
          />
          <CarouselDotButtons
            scrollSnaps={carousel.dots.scrollSnaps}
            selectedIndex={carousel.dots.selectedIndex}
            onClickDot={carousel.dots.onClickDot}
            sx={sxGalleryDots}
          />
        </>
      )}
    </Box>
  );
};

export { Gallery };
